export default "__VITE_PUBLIC_ASSET__8697f131__"